import React from 'react';
import { Database } from '../../server/database';
import GameCard from '../elements/GameCard';
import './GamesPage.css'

interface GamesPageState {
  play: boolean;
}

class GamesPage extends React.Component<{}, GamesPageState> {
  constructor(props:{}) {
    super(props);

    this.state = {
      play: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let isDeveloper = (window.location.href.indexOf('playplace.io') == -1);
    let cards = [];
    for (let i = 0; i < Database.games.length; i++) {
      if(Database.games[i].developer && !isDeveloper)
        continue;
      cards.push(<GameCard key={i} id={Database.games[i].id} link='play'/>);
    }

    return (
      <div className="games-page">
        <div className="games-page-text">
          Our games are free to play without an app to download.
        </div>
        <br/>
        <div className="play-games-container">
          {cards}
        </div>
        <br/>
        <div className="games-page-text">
          We will continue to add new games to our collection, so make sure to join our Twitter and Discord to be informed of upcoming releases.
        </div>
        <br/>
        <div style={{ display: "flex", justifyContent: 'center'}} >
          <img src="games-footer.png"></img>      
        </div>
      </div>
    );
  }
}

export default GamesPage;
